import { MypageTitle } from "../components/shared/Title";
import { Content } from "../components/mypageOrderShow/index";
import Aside from "../components/shared/MypageAside";
import Layout from "../components/Layout";

const MypageOrderShow = (props) => {
  return (
    <Layout>
      <div className="flex mypage_lectures default_margin mobile:flex-col max-w-[1200px] h-full">
        <div className="flex-0 web:mr-[58px] tablet:mr-[28px] mobile:hidden">
          <Aside pageName={props?.pageName} />
        </div>

        <div className="flex-grow w-full mobile:mt-5">
          <MypageTitle title="주문/배송 정보" />
          <Content orderId={props?.orderId} />
        </div>
      </div>
    </Layout>
  );
};

export default MypageOrderShow;
